module.exports = __webpack_public_path__ + "img/wenzhai-books.62ea9870.jpg";